import Rule from "../../../common/rule";
import { getMatchResult } from "../../utils/tennis-utils";

export default class FinalizeMatch extends Rule {
    // eslint-disable-next-line no-unused-vars
    async apply(gameContext, ruleContext, eventConfiguration, { match }) {
        const matchResult = getMatchResult(match, eventConfiguration) || {};

        match.winnerId =
            matchResult === "away"
                ? match.away.teamId
                : matchResult === "home"
                ? match.home.teamId
                : null;
    }
}
